import * as types from 'actions/action-types';

var initialState = {
    stock_parts: null,
    stock_parts_pending: false,
    stock_parts_save_pending: false,
    stock_parts_unsubscribe: false,

    stock_part_saved: null,
    stock_part_save_pending: false,

    stock_part_selected: null,
    stock_part_selected_pending: false,
    stock_part_selected_unsubscribe: false,
};

const StockPartsReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.STOCK_PARTS + '_PENDING': pending('stock_parts'); break;
        case types.STOCK_PARTS + '_SAVE_PENDING': save_pending('stock_parts'); break;
        case types.STOCK_PARTS + '_SAVE_FULFILLED': save_fulfilled('stock_parts'); break;
        case types.STOCK_PARTS + '_FULFILLED': fulfilled('stock_parts'); break;
        case types.STOCK_PARTS + '_CLEAR': clear('stock_parts', {}); break;

        case types.STOCK_PART + '_SAVE_PENDING': save_pending('stock_part'); break;
        case types.STOCK_PART + '_SAVE_FULFILLED': save_fulfilled('stock_part'); break;
        case types.STOCK_PART + '_FULFILLED': fulfilled('stock_part'); break;

        case types.STOCK_PART_SELECTED + '_PENDING': pending('stock_part_selected'); break;
        case types.STOCK_PART_SELECTED + '_FULFILLED': fulfilled('stock_part_selected'); break;

        default: break;
    }

    return state;

    function pending(table) {
        state = {
            ...state,
            [table + '_pending']: true,
        };
    }
    function save_pending(table) {
        state = {
            ...state,
            [table + '_save_pending']: true,
        };
    }
    function save_fulfilled(table) {
        state = {
            ...state,
            [table + '_saved']: action.data,
            [table + '_save_pending']: false,
        };
    }
    function fulfilled(table) {
        state = {
            ...state,
            [table]: action.data,
            [table + '_pending']: false,
            [table + '_unsubscribe']: (action.unsubscribe) ? action.unsubscribe : state[table + '_unsubscribe'],
        };
    }
    function clear(table, value) {
        state = {
            ...state,
            [table]: value,
        };
    }
};
export default StockPartsReducer;


